import * as React from "react";
import { Typography, Box } from "@mui/material";
import { ResponsiveContainer } from "@/components/dashboard/ResponsiveContainer";
import { InformationGrid } from "@/components/dashboard/InformationGrid";
import { OrderSummarySection } from "@/components/orders/sections/OrderSummarySection";
import { OrderStatusSection } from "@/components/orders/sections/OrderStatusSection";
import { OrdersTableSection } from "@/components/orders/sections/OrdersTableSection";

export function OrdersPage(): React.JSX.Element {
  return (
    <ResponsiveContainer>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          Orders
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Read-only view of Falcon's recorded order book — no placement, modification, or cancellation.
        </Typography>
      </Box>
      <InformationGrid>
        <OrderSummarySection />
        <OrderStatusSection />
      </InformationGrid>
      <Box sx={{ mt: 3 }}>
        <OrdersTableSection />
      </Box>
    </ResponsiveContainer>
  );
}
